import { IEmailProvider, EmailData, EmailResponse } from '../types';

/**
 * Web3Forms Provider - Servicio gratuito sin backend
 * Requiere: Access Key de https://web3forms.com
 * Gratis: Ilimitado
 */
export class Web3FormsProvider implements IEmailProvider {
  private accessKey: string;

  constructor() {
    this.accessKey = process.env.REACT_APP_WEB3FORMS_KEY || '';
  }

  async initialize(): Promise<void> {
    if (!this.accessKey) {
      throw new Error('Web3Forms Access Key not configured');
    }
  }

  async sendEmail(data: EmailData): Promise<EmailResponse> {
    try {
      const formData: any = {
        access_key: this.accessKey,
        name: data.name,
        email: data.email,
        message: data.message,
        subject: data.subject || `Nuevo mensaje de ${data.name} - Portfolio`,
        to: 'alex.quito.carranza@gmail.com',
      };

      // Web3Forms soporta reCAPTCHA para protección anti-spam adicional
      if (data.recaptchaToken) {
        formData['g-recaptcha-response'] = data.recaptchaToken;
      }

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        return {
          success: true,
          message: 'Email sent successfully via Web3Forms',
        };
      }

      throw new Error(result.message || 'Failed to send email');
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Failed to send email via Web3Forms',
      };
    }
  }
}
